import React from 'react';
import type { Product } from 'bundles/connect/types';
import { connect } from 'react-redux';

type ProductFeatureProps = {
  children: React.ReactNode;
  product: string;
  products: Product;
}

function ProductFeature({ children, product, products }: ProductFeatureProps): React.ReactElement | null {
  if (products[product]) return <>{children}</>;

  return null;
}

const mapStateToProps = ({ ui: { products } }) => ({ products });
export default connect(mapStateToProps, {})(ProductFeature);
